var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tab',{attrs:{"title":'day ' + _vm.id,"active":_vm.id == '1' ? true : false}},[_vm._v(" "+_vm._s(_vm.content)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }